import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/app/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _NOTIFICATION_TYPE_SE;

import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CloseOutlined, EditFilled, EditOutlined, ExclamationCircleOutlined, InfoCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Badge, Button, Collapse, Drawer as AntDrawer, Form, Input, message, Modal, Row, Space, Spin, Tooltip } from 'antd';
import { AppraisalType, NotificationType, TaskIncidenceState } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { getNotificationStore } from 'core/modules/notifications/notification.store';
import { getPreferencesStore } from 'core/modules/preferences/preferences.store';
import { TaskType } from 'core/modules/tasks/task.interface';
import { getTaskStore, TaskLoader } from 'core/modules/tasks/task.store';
import { Logger } from 'core/utils/logger';
import { useDebounce } from 'core/utils/time';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskTypeSelect } from 'src/components/Form/TaskTypeSelect';
import { TaskDrawerIncidences } from 'src/components/Tasks/Drawer/Incidences';
import { TaskIncidenceDrawer } from 'src/components/Tasks/IncidencesDrawer';
import { TaskReferenceView } from 'src/components/Tasks/Reference';
import { eventStopPropagation } from 'src/utils/button';
import { classes } from 'src/utils/classes';
import { formIsTouched } from 'src/utils/form';
import { setRouterQuery } from 'src/utils/router';
import styled from 'styled-components';
import { LabelSelect } from '../Form/LabelsSelect';
import { UserSelect } from '../Form/UserSelect';
import { TaskActivity } from './Activity';
import { TaskComments } from './Comments';
import { TaskDrawerFooter } from './Drawer/Footer';
import { TaskFormContent } from './Form/Content';
import { TaskFormDeadline } from './Form/Deadline';
import { TaskDocuments } from './Form/Documents';
import { TaskProgress } from './Progress';
import { TaskVersioning } from './Versioning';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var NOTIFICATION_TYPE_SECTION = (_NOTIFICATION_TYPE_SE = {}, _defineProperty(_NOTIFICATION_TYPE_SE, NotificationType.TaskAssigned, 'general'), _defineProperty(_NOTIFICATION_TYPE_SE, NotificationType.TaskReviewAssigned, 'general'), _defineProperty(_NOTIFICATION_TYPE_SE, NotificationType.TaskCommentAdded, 'comment'), _defineProperty(_NOTIFICATION_TYPE_SE, NotificationType.TaskIncidenceAdded, 'incidence'), _defineProperty(_NOTIFICATION_TYPE_SE, NotificationType.TaskDocumentAdded, 'document'), _NOTIFICATION_TYPE_SE);
var CHECK_REFERENCE_DEBOUNCE = 500;
var logger = new Logger('view.TaskDrawer'); // Drawer that shows the details for a given task.

export var TaskDrawer = function TaskDrawer(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();

  var _getAuthStore = getAuthStore(),
      canManageTasks = _getAuthStore.canManageTasks;

  var _getTaskStore = getTaskStore(),
      isLoading = _getTaskStore.isLoading,
      isLoadingKey = _getTaskStore.isLoadingKey,
      tasks = _getTaskStore.tasks,
      populateTask = _getTaskStore.populateTask,
      getTaskById = _getTaskStore.getTaskById,
      taskByReference = _getTaskStore.taskByReference,
      fetchTaskWithReference = _getTaskStore.fetchTaskWithReference,
      getIncidenceById = _getTaskStore.getIncidenceById,
      createTask = _getTaskStore.createTask,
      updateTask = _getTaskStore.updateTask,
      deleteTask = _getTaskStore.deleteTask,
      loadTaskMedia = _getTaskStore.loadTaskMedia;

  var _getNotificationStore = getNotificationStore(),
      activeNotification = _getNotificationStore.activeNotification;

  var _getPreferencesStore = getPreferencesStore(),
      preferences = _getPreferencesStore.preferences;

  var _useState = useState(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  var _useState2 = useState(TaskType.Report),
      newTaskType = _useState2[0],
      setNewTaskType = _useState2[1];

  var _useState3 = useState(false),
      createAnother = _useState3[0],
      setCreateAnother = _useState3[1];

  var _useState4 = useState(null),
      rawActiveTask = _useState4[0],
      setActiveTask = _useState4[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState5 = useState(false),
      isCreatingIncidence = _useState5[0],
      setCreatingIncidence = _useState5[1];

  var _useState6 = useState(),
      activeIncidenceId = _useState6[0],
      setActiveIncidenceId = _useState6[1];

  var _useState7 = useState(''),
      currentReference = _useState7[0],
      setCurrentReference = _useState7[1];

  var isCreating = !props.taskId;
  var isReadonly = !isExpanded;
  var activeTask = useMemo(function () {
    return rawActiveTask ? populateTask(rawActiveTask) : null;
  }, [rawActiveTask]);
  var taskType = useMemo(function () {
    var _activeTask$content$t;

    return isCreating ? newTaskType : (_activeTask$content$t = activeTask === null || activeTask === void 0 ? void 0 : activeTask.content.type) !== null && _activeTask$content$t !== void 0 ? _activeTask$content$t : TaskType.Report;
  }, [newTaskType, isCreating, activeTask]);
  var task = useMemo(function () {
    return getTaskById(props.taskId);
  }, [props.taskId, tasks]);
  var incidence = useMemo(function () {
    return getIncidenceById(activeIncidenceId);
  }, [task, activeIncidenceId]);
  var size = isExpanded ? 900 : 550;
  var activeIncidences = useMemo(function () {
    var _activeTask$incidence;

    return (_activeTask$incidence = activeTask === null || activeTask === void 0 ? void 0 : activeTask.incidences.filter(function (incidence) {
      return incidence.state === TaskIncidenceState.Pending;
    }).length) !== null && _activeTask$incidence !== void 0 ? _activeTask$incidence : 0;
  }, [activeTask]);
  var debouncedCurrentReference = useDebounce(currentReference, CHECK_REFERENCE_DEBOUNCE);
  var taskWithReference = useMemo(function () {
    var foundTask = taskByReference(currentReference);
    return (foundTask === null || foundTask === void 0 ? void 0 : foundTask.id) === (task === null || task === void 0 ? void 0 : task.id) ? undefined : foundTask;
  }, [currentReference, tasks, task]);

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var _values$deadline, _task;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if ((_values$deadline = values.deadline) !== null && _values$deadline !== void 0 && _values$deadline.toDate) {
                values.deadline = values.deadline.toDate();
              }

              if (!isCreating) {
                _context.next = 10;
                break;
              }

              _context.next = 5;
              return createTask(values);

            case 5:
              _task = _context.sent;
              message.success(t("tasks.created"));

              if (createAnother) {
                form.resetFields();
              } else {
                props.onTaskCreated && props.onTaskCreated(_task.id);
              }

              _context.next = 15;
              break;

            case 10:
              values.state = task.state;
              _context.next = 13;
              return updateTask(props.taskId, values);

            case 13:
              message.success(t("tasks.updated"));
              props.onTaskUpdated && props.onTaskUpdated(task.id);

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              message.error(t('unknownError'));

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function onDeletionConfirmed() {
    return _onDeletionConfirmed.apply(this, arguments);
  }

  function _onDeletionConfirmed() {
    _onDeletionConfirmed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                if (props.taskId) {
                  deleteTask(props.taskId);
                }

                props.onClose();
              } catch (error) {
                logger.error(error);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _onDeletionConfirmed.apply(this, arguments);
  }

  function onClose() {
    if (formIsTouched(form)) {
      Modal.confirm({
        title: t('confirmClose.title'),
        icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {}),
        content: t('confirmClose.description'),
        okText: t('confirmClose.discard'),
        cancelText: t('cancel'),
        onOk: props.onClose
      });
    } else {
      props.onClose();
    }
  } // Control changes in the form


  useEffect(function () {
    var _task$reference;

    if (props.isVisible) {
      form.resetFields();

      if (!task) {
        setExpanded(true);
        setActiveTask(undefined);
      }
    }

    setCreatingIncidence(false);
    setActiveIncidenceId(undefined);
    setCurrentReference((_task$reference = task === null || task === void 0 ? void 0 : task.reference) !== null && _task$reference !== void 0 ? _task$reference : '');
  }, [props.isVisible, task]);
  useEffect(function () {
    if (task) {
      setActiveTask(_objectSpread({}, task));
      loadTaskMedia(task);
    }
  }, [task]);
  useEffect(function () {
    if (router.query.expanded) {
      setExpanded(true);
    }
  }, [props.isVisible, router.query.expanded]);
  useEffect(function () {
    var section;

    if (props.isVisible) {
      if (router.query.incidenceId) {
        section = "incidence-".concat(router.query.incidenceId);
      } else if (activeNotification) {
        section = NOTIFICATION_TYPE_SECTION[activeNotification.content.type];

        if (activeNotification.content.type === NotificationType.TaskCommentAdded) {
          section = "".concat(section, "-").concat(activeNotification.content.comment);
        }

        if (activeNotification.content.type === NotificationType.TaskDocumentAdded) {
          section = "".concat(section, "-").concat(activeNotification.content.document);
        }

        if (activeNotification.content.type === NotificationType.TaskIncidenceAdded) {
          section = "".concat(section, "-").concat(activeNotification.content.incidence);
        }
      }

      if (section) {
        var href = window.location.href;

        if (href.includes('#')) {
          href = href.substring(0, href.indexOf('#'));
        }

        href += "#".concat(section);
        window.location.href = href;
      }
    }
  }, [props.isVisible, activeNotification === null || activeNotification === void 0 ? void 0 : activeNotification.id, router.query.incidenceId]);
  useEffect(function () {
    if (debouncedCurrentReference && !taskByReference(debouncedCurrentReference)) {
      fetchTaskWithReference(debouncedCurrentReference);
    }
  }, [debouncedCurrentReference]);
  return /*#__PURE__*/_jsxs(Container, {
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "title",
        children: isCreating ? t('tasks.new') : /*#__PURE__*/_jsx(TaskReferenceView, {
          task: task
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "actions",
        children: [props.canToggleExpanded && /*#__PURE__*/_jsx(Button, {
          type: "ghost",
          onClick: function onClick() {
            setExpanded(!isExpanded);
            setRouterQuery(router, 'expanded');
          },
          children: isExpanded ? /*#__PURE__*/_jsx(EditFilled, {}) : /*#__PURE__*/_jsx(EditOutlined, {})
        }), /*#__PURE__*/_jsx(Button, {
          type: "ghost",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(CloseOutlined, {})
        })]
      })]
    }),
    placement: "right",
    width: size,
    mask: props.mask || isExpanded,
    onClose: !isLoading && onClose,
    closable: !isLoading,
    closeIcon: false,
    open: props.isVisible,
    children: [/*#__PURE__*/_jsxs(Form, {
      name: "modifyTask",
      form: form,
      initialValues: _objectSpread({
        content: {
          type: taskType,
          appraisalType: AppraisalType.InPerson,
          rate: preferences === null || preferences === void 0 ? void 0 : preferences.defaultReportRate
        }
      }, task),
      onFinish: onSubmit,
      layout: "vertical",
      colon: false,
      children: [!!activeTask && /*#__PURE__*/_jsx(TaskProgress, {
        task: activeTask,
        isExpanded: isExpanded,
        onStateChanged: function onStateChanged() {
          return props.onTaskUpdated && props.onTaskUpdated(task.id);
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "blocks-container",
        id: "general",
        children: [/*#__PURE__*/_jsx(Collapse, {
          defaultActiveKey: ['general'],
          ghost: true,
          children: /*#__PURE__*/_jsxs(Collapse.Panel, {
            header: t('tasks.sections.general'),
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: ['content', 'type'],
              label: t('form.task.type.label'),
              rules: isReadonly ? undefined : [{
                required: true,
                message: t('form.task.type.error.required')
              }],
              children: /*#__PURE__*/_jsx(TaskTypeSelect, {
                isReadonly: isReadonly || !isCreating,
                onChange: setNewTaskType
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "reference",
              className: "reference-item",
              label: /*#__PURE__*/_jsxs("div", {
                className: "reference-label",
                children: [/*#__PURE__*/_jsx("span", {
                  children: t('form.task.reference.label')
                }), isCreating && currentReference && /*#__PURE__*/_jsxs(Space, {
                  className: "reference-extra",
                  children: [(isLoadingKey(TaskLoader.FetchByReference) || !taskWithReference && currentReference !== debouncedCurrentReference) && /*#__PURE__*/_jsx(Spin, {
                    indicator: /*#__PURE__*/_jsx(LoadingOutlined, {
                      style: {
                        fontSize: 10
                      }
                    })
                  }), taskWithReference && /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx(Button, {
                      type: "link",
                      onClick: function onClick() {
                        setRouterQuery(router, 'taskId', taskWithReference.id);
                        setRouterQuery(router, 'expanded', 'true');
                      },
                      children: t('tasks.open', {
                        reference: taskWithReference.reference
                      })
                    }), /*#__PURE__*/_jsx(Tooltip, {
                      title: t('tasks.references.existingHelp'),
                      children: /*#__PURE__*/_jsx(InfoCircleOutlined, {})
                    })]
                  }), !taskWithReference && !isLoadingKey(TaskLoader.FetchByReference) && (task === null || task === void 0 ? void 0 : task.reference) !== currentReference && currentReference === debouncedCurrentReference && /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "new-reference",
                      children: t('tasks.references.new')
                    }), /*#__PURE__*/_jsx(Tooltip, {
                      title: t('tasks.references.newHelp'),
                      children: /*#__PURE__*/_jsx(InfoCircleOutlined, {})
                    })]
                  })]
                })]
              }),
              rules: !canManageTasks || isReadonly ? undefined : [{
                required: true,
                message: t('form.task.reference.error.required')
              }],
              children: /*#__PURE__*/_jsx(Input, {
                bordered: canManageTasks && !isReadonly,
                readOnly: !canManageTasks || isReadonly,
                onChange: function onChange(ev) {
                  return setCurrentReference(ev.target.value);
                },
                placeholder: !canManageTasks || isReadonly ? undefined : t('form.task.reference.placeholder')
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "title",
              label: t('form.task.title.label'),
              children: /*#__PURE__*/_jsx(Input, {
                bordered: !isReadonly,
                readOnly: isReadonly,
                placeholder: isReadonly ? t('form.task.title.empty') : t('form.task.title.placeholder')
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "description",
              label: t('form.task.description.label'),
              children: /*#__PURE__*/_jsx(Input.TextArea, {
                autoSize: {
                  minRows: isReadonly ? undefined : 2
                },
                bordered: !isReadonly,
                readOnly: isReadonly,
                placeholder: isExpanded ? t('form.task.description.placeholder') : t('form.task.description.empty')
              })
            }), /*#__PURE__*/_jsx(TaskFormDeadline, {
              isReadonly: isReadonly
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "assignedToUserId",
              label: t('form.task.assignee.label'),
              className: classes({
                highlighted: (activeNotification === null || activeNotification === void 0 ? void 0 : activeNotification.content.type) === NotificationType.TaskAssigned
              }),
              children: /*#__PURE__*/_jsx(UserSelect, {
                isReadonly: !canManageTasks || isReadonly,
                allowClear: true,
                placeholder: t('form.task.assignee.placeholder'),
                emptyMessage: t('form.task.assignee.empty')
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "reviewerId",
              label: t('form.task.reviewer.label'),
              className: classes({
                highlighted: (activeNotification === null || activeNotification === void 0 ? void 0 : activeNotification.content.type) === NotificationType.TaskReviewAssigned
              }),
              children: /*#__PURE__*/_jsx(UserSelect, {
                isReadonly: isReadonly,
                allowClear: true,
                placeholder: t('form.task.reviewer.placeholder'),
                emptyMessage: t('form.task.reviewer.empty')
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              label: t('form.task.labels.label'),
              name: "labelIds",
              children: /*#__PURE__*/_jsx(LabelSelect, {
                isReadonly: isReadonly,
                isMultiple: true,
                allowClear: true,
                placeholder: t('form.task.labels.placeholder'),
                emptyMessage: t('form.task.labels.empty')
              })
            })]
          }, "general")
        }), /*#__PURE__*/_jsxs(Collapse, {
          defaultActiveKey: ['content', 'versioning'],
          ghost: true,
          children: [/*#__PURE__*/_jsx(Collapse.Panel, {
            header: t("tasks.sections.".concat(taskType)),
            children: /*#__PURE__*/_jsx(TaskFormContent, {
              type: taskType,
              canEdit: canManageTasks,
              isReadonly: isReadonly
            })
          }, "content"), activeTask && /*#__PURE__*/_jsx(Collapse.Panel, {
            header: t('tasks.sections.versions'),
            children: /*#__PURE__*/_jsx(TaskVersioning, {
              task: activeTask
            })
          }, "versioning")]
        })]
      }), isExpanded && /*#__PURE__*/_jsx(TaskDrawerFooter, {
        isLoading: isLoading,
        isCreating: isCreating,
        createAnother: createAnother,
        form: form,
        setCreateAnother: setCreateAnother,
        onDeletionConfirmed: onDeletionConfirmed
      })]
    }), activeTask && /*#__PURE__*/_jsxs(Collapse, {
      defaultActiveKey: ['documents', 'photos', 'reports'],
      ghost: true,
      children: [/*#__PURE__*/_jsx(Collapse.Panel, {
        header: /*#__PURE__*/_jsx(Badge, {
          count: activeTask.numDocuments,
          offset: [15, 7],
          children: t('tasks.sections.documents')
        }),
        id: "documents",
        children: /*#__PURE__*/_jsx(TaskDocuments, {
          fromNotifications: props.fromNotifications,
          task: activeTask,
          isExpanded: isExpanded,
          type: "document"
        })
      }, "documents"), /*#__PURE__*/_jsx(Collapse.Panel, {
        header: /*#__PURE__*/_jsx(Badge, {
          count: activeTask.numPhotos,
          offset: [15, 7],
          children: t('tasks.sections.photos')
        }),
        children: /*#__PURE__*/_jsx(TaskDocuments, {
          fromNotifications: props.fromNotifications,
          task: activeTask,
          isExpanded: isExpanded,
          type: "photo"
        })
      }, "photos"), /*#__PURE__*/_jsx(Collapse.Panel, {
        header: /*#__PURE__*/_jsx(Badge, {
          count: activeTask.numReports,
          offset: [15, 7],
          children: t('tasks.sections.reports')
        }),
        children: /*#__PURE__*/_jsx(TaskDocuments, {
          fromNotifications: props.fromNotifications,
          task: activeTask,
          isExpanded: isExpanded,
          type: "report"
        })
      }, "reports")]
    }), /*#__PURE__*/_jsxs("div", {
      className: "blocks-container",
      children: [!!activeTask && /*#__PURE__*/_jsx(Collapse, {
        defaultActiveKey: ['comments'],
        ghost: true,
        children: /*#__PURE__*/_jsx(Collapse.Panel, {
          header: /*#__PURE__*/_jsx(Badge, {
            count: activeTask.comments.length,
            offset: [15, 7],
            children: t('tasks.sections.comments')
          }),
          id: "comments",
          children: /*#__PURE__*/_jsx(TaskComments, {
            task: activeTask
          })
        }, "comments")
      }), !!activeTask && /*#__PURE__*/_jsx(Collapse, {
        defaultActiveKey: ['incidences'],
        ghost: true,
        children: /*#__PURE__*/_jsx(Collapse.Panel, {
          header: /*#__PURE__*/_jsxs(Row, {
            justify: "space-between",
            children: [/*#__PURE__*/_jsx(Badge, {
              count: activeIncidences,
              offset: [15, 7],
              children: t('tasks.sections.incidences')
            }), canManageTasks && /*#__PURE__*/_jsx(Button, {
              type: "link",
              className: "add-incidences-btn",
              onClick: function onClick(ev) {
                eventStopPropagation(ev);
                setCreatingIncidence(true);
              },
              children: /*#__PURE__*/_jsx(PlusOutlined, {})
            })]
          }),
          id: "incidences",
          children: /*#__PURE__*/_jsx(TaskDrawerIncidences, {
            task: activeTask,
            onIncidenceSelected: setActiveIncidenceId
          })
        }, "incidences")
      }), !!activeTask && /*#__PURE__*/_jsx(Collapse, {
        defaultActiveKey: ['activity'],
        ghost: true,
        children: /*#__PURE__*/_jsx(Collapse.Panel, {
          header: t('tasks.sections.activity'),
          children: /*#__PURE__*/_jsx(TaskActivity, {
            task: activeTask
          })
        }, "activity")
      })]
    }), /*#__PURE__*/_jsx(TaskIncidenceDrawer, {
      task: activeTask,
      incidence: incidence,
      isVisible: isCreatingIncidence || !!incidence,
      onClose: function onClose() {
        setCreatingIncidence(false);
        setActiveIncidenceId(undefined);
      }
    })]
  });
};
var Container = styled(AntDrawer).withConfig({
  displayName: "TaskDrawer__Container",
  componentId: "sc-mlfd6m-0"
})([".ant-drawer-content-wrapper{max-width:100vw;}.ant-drawer-title{padding-right:48px;.actions{position:absolute;top:12px;right:12px;z-index:999;.ant-btn{width:32px;height:32px;border:none;&:after{display:none;}}}}.ant-drawer-body{padding-bottom:50px;}.image-item > .ant-form-item-control{margin:auto;text-align:center;}.ant-form{label{font-weight:bold;}.ant-form-item{margin-bottom:24px;}.ant-form-item-control-input{min-height:0;}}.ant-select,.ant-picker{width:100%;}.blocks-container{display:flex;flex-wrap:wrap;margin-left:-24px;margin-right:-24px;.ant-collapse{margin-left:0px;margin-right:0px;flex:1;min-width:400px;}}.block{flex:1;min-width:400px;padding:0 24px;}.ant-collapse{margin-left:-24px;margin-right:-24px;.ant-collapse-header,.ant-badge{font-size:16px;}}.title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;}.reference-item label{width:100%;.reference-label{display:flex;align-items:center;justify-content:space-between;width:100%;height:24px;.ant-spin{height:20px;}.ant-btn{color:", ";padding:0;height:auto;span{text-decoration:underline;}}.new-reference{font-weight:normal;color:", ";}}}.ant-collapse{.ant-collapse-header{background-color:", ";border-top:1px solid #f0f0f0;border-bottom:1px solid #f0f0f0;}.ant-collapse-content{border-left:1px solid #f0f0f0;border-right:1px solid #f0f0f0;}}.add-incidences-btn{padding:0;height:auto;}"], Colors.primary, Colors.magenta[4], Colors.lightestGrey);